// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"f3d6407e","799":"4321a5e1"}[chunkId] + ".chunk.css";
};